export enum Field {
    AGE_BASE = 'AGE_BASE',
    AGE_QUOTE = 'AGE_QUOTE',
    CURVE_PROGRESS = 'CURVE_PROGRESS',
    CURVE_PROGRESS_AGE = 'CURVE_PROGRESS_AGE',
    MARKET_CAP = 'MARKET_CAP',
    SWAP_ALL = 'SWAP_ALL',
    SWAP_BUY = 'SWAP_BUY',
    SWAP_SELL = 'SWAP_SELL',
    VENUE_PUMPFUN = 'VENUE_PUMPFUN',
    VENUE_PUMPUP = 'VENUE_PUMPUP',
}
